module.exports = __webpack_public_path__ + "static/media/topbanner.f6fb8825.png";